/**
 * Used to strip the non-numeric characters from a string.
 * Currency is a good example.  It will remove the currency characters.
 * @param value
 */
export const stripNumberFormatting = value => {
  if (typeof value === 'number') return value;
  return Number(value.replace(/[^0-9.-]+/g, ''));
};